import { JsonProperty } from "../../../models/utilities/json-property";
import { ValidateProperty } from "../../../models/utilities/validate-property";

export class PickupUpdate {

    @ValidateProperty({ required: true })
    @JsonProperty({ toType: 'datetime-specific' })
    public pickupTimeLocal : Date|undefined = undefined;
    
    @ValidateProperty({ required: true })
    public orders : string[] = [];
    
    @ValidateProperty({ required: true })
    public rowVersion : string = '';

}
